<template>
  <div class="container">
    <div class="bgoverlay">
      <div class="bg" :style="{'background-image': `url(${require('@/assets/images/msdsbg.jpg')})`}"></div>
    </div>
    <div class="inner-pannel">
      <div class="pannel-content">
        <div class="pannel-content-box maxwidth-lg topPoint">
          <div style="height:55px;"></div>
          <div class="content-page">
            <div class="ani animate__animated animate__fadeInUp">
              <div :class="$i18n.locale=='zh'?'zh-font':'en-font'" style="color:#ffffff;">{{$t('independentlySoftware.content')}}</div>
              <div style="height:20px"></div>
              <el-collapse
                style="width:577px"
                :accordion="true"
              >
                <el-collapse-item :title="$t('technology.function[2].subName[0]')">
                  <div :class="$i18n.locale=='zh'?'zh-font':'en-font'" style="color:#ffffff;">{{ $t('independentlySoftware.content1') }}</div>
                  <div style="height:20px"></div>
                  <img style="width:100%" src="@/assets/images/msds.jpg">
                </el-collapse-item>
                <el-collapse-item :title="$t('technology.function[2].subName[1]')">
                  <div :class="$i18n.locale=='zh'?'zh-font':'en-font'" style="color:#ffffff;">{{ $t('independentlySoftware.content2') }}</div>
                  <div style="height:20px;"></div>
                  <img style="width:100%" src="@/assets/images/independent1.png">
                </el-collapse-item>
                <el-collapse-item :title="$t('technology.function[2].subName[2]')">
                  <div :class="$i18n.locale=='zh'?'zh-font':'en-font'" style="color:#ffffff;">{{ $t('independentlySoftware.content3') }}</div>
                  <div style="height:20px;"></div>
                  <img style="width:100%" src="@/assets/images/independent2.png">
                </el-collapse-item>
                <el-collapse-item :title="$t('technology.function[2].subName[3]')">
                  <div :class="$i18n.locale=='zh'?'zh-font':'en-font'" style="color:#ffffff;">{{ $t('independentlySoftware.content4') }}</div>
                  <div style="height:20px;"></div>
                  <img style="width:100%" src="@/assets/images/ncm.png">
                </el-collapse-item>
                <!-- <el-collapse-item :title="$t('technology.function[2].subName[4]')">
                  <div :class="$i18n.locale=='zh'?'zh-font':'en-font'" style="color:#ffffff;">{{ $t('independentlySoftware.content5') }}</div>
                  <div style="height:20px;"></div>
                  <img style="width:50%" src="@/assets/images/independent3.png">
                </el-collapse-item> -->
              </el-collapse>
              <!-- <p class="link" style="color: #ed6d00" @click="goTo('3-1')">{{$t('technology.function[2].subName[0]')}}</p>
              <div style="height:20px"></div>
              <p class="link" style="color: #ed6d00" @click="goTo('3-2')">{{$t('technology.function[2].subName[1]')}}</p>
              <div style="height:20px"></div>
              <p class="link" style="color: #ed6d00" @click="goTo('3-3')">{{$t('technology.function[2].subName[2]')}}</p>
              <div style="height:20px"></div>
              <p class="link" style="color: #ed6d00" @click="goTo('3-4')">{{$t('technology.function[2].subName[3]')}}</p>
              <div style="height:20px"></div>
              <p class="link" style="color: #ed6d00" @click="goTo('3-5')">{{$t('technology.function[2].subName[4]')}}</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default({
  data() {
    return {

    }
  },
  methods: {
    goTo(path) {
      // this.$router.push({path:'/technology/independentlySoftware',query: { index: path}})
      this.$emit('goToDetail', path)
    }
  }
})
</script>

<style scoped>
  .topPoint::after {
      width: 25px;
      height: 25px;
      content: "";
      position: absolute;
      background: #ed6d00;
      border-radius: 50%;
      z-index: 1;
      top: -12.5px;
      right: -12.5px;
  }
  .inner-pannel{
      min-height: 100%;
      padding-bottom: 54px;
      position: static;
      /* position: relative; */
      /* position: absolute; */
      width: 100%;
  }
  .right-color{
    color: #ed6d00;
  }
  .link{
    cursor:pointer;
  }
  /deep/ .el-collapse-item__wrap{
    padding-left: 0;
  }
  /deep/ .el-collapse {
    border-bottom: 0;
  }
  /deep/ .el-collapse-item__wrap{
    border-bottom: 0;
  }
  @media screen and (max-width:768px) {
    /deep/ .el-collapse {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/independentlySoftware/independentlySoftware.vue